
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[id]",
      function () {
        return require("private-next-pages/[id]/index.tsx");
      }
    ]);
  